"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canPathIgnoreAuth = void 0;
var _reactRouterDom = require("react-router-dom");
var canPathIgnoreAuth = function canPathIgnoreAuth(path) {
  var ignorePaths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return !!ignorePaths.find(function (ignorePath) {
    return (0, _reactRouterDom.matchPath)(path, {
      path: "".concat(process.env.PUBLIC_URL).concat(ignorePath),
      exact: true
    });
  });
};
exports.canPathIgnoreAuth = canPathIgnoreAuth;